import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { Base_Url } from '../config';
import { useSelector } from 'react-redux';

const UploadModal = ({ modal, closeModal, editObj, fetchHod }) => {
  const [formData, setFormData] = useState({
    file: null,
    sectionTitle: '',
    name: '',
    researchInterest: '',
    email: '',
    office: '',
    webpageurl: '',
    phone: ''
  });
  const [errors, setErrors] = useState({});
  const userfromwebmaster = useSelector((state) => state.user);
  const facultstaff = useSelector((state) => state.facultyuser);
 
  useEffect(() => {
    if (editObj) {
      setFormData({
        file: null,
        sectionTitle: editObj.sectionTitle || '',
        researchInterest: editObj.researchInterest || '',
        name: editObj.name || '',
        email: editObj.email || '',
        office: editObj.office || '',
        webpageurl: editObj.webpageurl || '',
        phone: editObj.phone || ''
      });
    }
  }, [editObj]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.file) newErrors.file = 'This field is required';
    if (!formData.name) newErrors.name = 'This field is required';
    if (!formData.sectionTitle) newErrors.sectionTitle = 'This field is required';
    // if (!formData.researchInterest) newErrors.researchInterest = 'This field is required';
    if (!formData.email) newErrors.email = 'This field is required';
    // if (!formData.office) newErrors.office = 'This field is required';
    if (!formData.phone) newErrors.phone = 'This field is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const data = new FormData();
      data.append('image', formData.file);  
      data.append('name', formData.name); 
      data.append('designation', formData.sectionTitle); 
      data.append('research_areas', formData.researchInterest);
      data.append('email', formData.email);
      data.append('office', formData.office);
      data.append('webpage_url', formData.webpageurl);
      data.append('phone', formData.phone);
      data.append('created_by', userfromwebmaster?.userExists ? userfromwebmaster?.userData?.userid :facultstaff.facultyprofileData.user_id  );
      try {
        const response = await axios.post(`${Base_Url}/profile`, data);
      
        if (response.data && response.data.message) {
          // console.log(response.data.message); 
        }
        
        closeModal();
        fetchHod();
        setFormData({
          file: null,
          sectionTitle: '',
          name: '',
          researchInterest: '',
          email: '',
          office: '',
          webpageurl: '',
          phone: ''
        });
      } catch (error) {
        console.error('Error uploading file and inserting data:', error);
        if (error.response && error.response.data && error.response.data.error) {
          console.error(error.response.data.error); 
        } else {
          console.error(error);
        }
      }
    }
  };

  return (
    <Modal show={modal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>{editObj ? 'Edit HOD Maths' : 'Add HOD Maths'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formFile">
            <Form.Label>Upload Photo</Form.Label>
            <Form.Control 
              type="file" 
              name="file"
              onChange={handleChange} 
              accept="image/png, image/jpeg, image/jpg, image/gif"
            />
            {errors.file && <span className="text-danger">{errors.file}</span>}
          </Form.Group>

          <Form.Group controlId="formName" className="mb-1">
            <Form.Label className="mt-2">Name</Form.Label>
            <Form.Control 
              type="text" 
              name="name"
              placeholder="Name" 
              value={formData.name} 
              onChange={handleChange} 
            />
            {errors.name && <span className="text-danger">{errors.name}</span>}
          </Form.Group>
          
          <Form.Group controlId="formSectionTitle" className="mb-1">
            <Form.Label className="mt-2">Designation</Form.Label>
            <Form.Control 
              type="text" 
              name="sectionTitle"
              placeholder="Designation" 
              value={formData.sectionTitle} 
              onChange={handleChange} 
            />
            {errors.sectionTitle && <span className="text-danger">{errors.sectionTitle}</span>}
          </Form.Group>
          
          <Form.Group controlId="formResearchInterest" className="mb-1">
            <Form.Label className="mt-2">Research Interests</Form.Label>
            <Form.Control 
                 as="textarea"  
              name="researchInterest"
              placeholder="Research Interest" 
              value={formData.researchInterest} 
              onChange={handleChange} 
              rows={3} 
            />
            {errors.researchInterest && <span className="text-danger">{errors.researchInterest}</span>}
          </Form.Group>

      
          
          <Form.Group controlId="formEmail" className="mb-1">
            <Form.Label className="mt-2">Email</Form.Label>
            <Form.Control 
              type="email" 
              name="email"
              placeholder="Email" 
              value={formData.email} 
              onChange={handleChange} 
            />
            {errors.email && <span className="text-danger">{errors.email}</span>}
          </Form.Group>
          
          <Form.Group controlId="formOffice" className="mb-1">
            <Form.Label className="mt-2">Office</Form.Label>
            <Form.Control 
              type="text" 
              name="office"
              placeholder="Office" 
              value={formData.office} 
              onChange={handleChange} 
            />
            {errors.office && <span className="text-danger">{errors.office}</span>}
          </Form.Group>
          
          <Form.Group controlId="formPhone" className="mb-1">
            <Form.Label className="mt-2">Phone</Form.Label>
            <Form.Control 
              type="text" 
              name="phone"
              placeholder="Phone" 
              value={formData.phone} 
              onChange={handleChange} 
            />
            {errors.phone && <span className="text-danger">{errors.phone}</span>}
          </Form.Group>
          
          <Form.Group controlId="formWebpageUrl" className="mb-1">
            <Form.Label className="mt-2">Webpage Url</Form.Label>
            <Form.Control 
              type="text" 
              name="webpageurl"
              placeholder="Webpage Url" 
              value={formData.webpageurl} 
              onChange={handleChange} 
            />
            {errors.webpageurl && <span className="text-danger">{errors.webpageurl}</span>}
          </Form.Group>
          
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default UploadModal;
